export const annotation_state = {
	show_disabled_view: false,
	annotations: null,
	annotations_options_presence_map: {},
	annotationVersionMap: {},
	annotations_popup_state: {},
	annotations_popup_data: {},
	selections: {},
	group_selections: {},
	annotations_stuff: [],
	sequence_num: 0,
	page_num: 1,
	extra_value: {},
	reportSavedBy: null,
	defaultSubOpts: {}
};

export const init_pathology_state = {
	annotations_stuff: []
};

export const annotation_state_store = {
	show_disabled_view: false,
	annotations: null,
	annotations_options_presence_map: {},
	annotationVersionMap: {},
	annotations_popup_state: {},
	annotations_popup_data: {},
	selections: {},
	group_selections: {},
	annotations_stuff: [],
	sequence_num: 0,
	page_num: 1,
	extra_value: {},
	reportSavedBy: null,
	defaultSubOpts: {}
};

export const patientViewerState = {
	hasUnsavedChanges: 0, //could be 0 or 1
	isOriginal: false, // default false
	current_annotation: {
	  id: -1, // IF -1: no annotation selected; ELSE IF 0: toolbar rectangle ROI; ELSE annotation id;
	  color: "#fff",
	},
	keyImageIds: {},
	annotationList: {},
	annotationBoundingBoxView: {},
	hasAnnotationUnsavedChanges: 0, // IF 0: no unsaved changes; 1: unsaved changes
	last_selected_bb: null,
	annotationPromise: null,
	originalStackIndex: -1,
  };

  export const eventBus = {
	on(event, callback) {
	  document.addEventListener(event, (e) => callback(e.detail));
	},
	dispatch(event, data) {
	  document.dispatchEvent(new CustomEvent(event, { detail: data }));
	},
	remove(event, callback) {
	  document.removeEventListener(event, callback);
	},
  };